<template>
	<div class="tabs-form">
		<!-- <div
			class="tabs"
			v-if="
				$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
				$store.state.user.userInfo.type === $api.account.types.OTHER.value ||
				$store.state.user.userInfo.type === $api.account.types.SCHOOL_ADMIN.value
			"
		>
			<div
				@click="handleTabClick(item.id)"
				v-for="item in tabs"
				:key="item.id"
				:class="['tabs-pane', fb_subject_id === item.id && 'tabs-pane-avtive']"
			>
				{{ item.name }}
			</div>
		</div>
		<div class="tabs" v-else>
			<div
				v-for="item in identity"
				:key="item.id"
				@click="tabId = item.id"
				:class="['tabs-pane', tabId === item.id && 'tabs-pane-avtive']"
			>
				{{ item.name }}
			</div>
		</div> -->
		<div class="tabs" v-if="$store.state.user.userInfo.type !== $api.account.types.RESEARCH.value">
			<div
				v-for="item in identity"
				:key="item.id"
				@click="handlePrivateClick(item.id)"
				:class="['tabs-pane', tabId == item.id && 'tabs-pane-avtive']"
			>
				{{ item.name }}
			</div>
		</div>

		<el-form :inline="true" class="form" ref="form" :model="form">
			<div class="form-contain">
				<el-form-item prop="fu_body_raw">
          <InputTopTip v-model="form.fu_body_raw" placeholder="题干名称">
            <el-input
              v-model="form.fu_body_raw"
              size="small"
              class="width-161"
              @keyup.native.enter=";(page = 1), getQuestionList()"
              placeholder=""
            ></el-input>
          </InputTopTip>
				</el-form-item>

				<el-form-item prop="publisher_id">
          <InputTopTip v-model="form.publisher_id" placeholder="出版社">
            <el-select
              v-model="form.publisher_id"
              size="small"
              placeholder=""
              class="width-121"
              @change="formChange($event, '出版社')"
            >
              <el-option v-for="item in publisherIdTags" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </InputTopTip>
				</el-form-item>
				<el-form-item prop="textbook_id">
          <InputTopTip v-model="form.textbook_id" placeholder="教材">
            <el-select
              v-model="form.textbook_id"
              size="small"
              :disabled="!!!form.publisher_id"
              placeholder=""
              class="width-121"
              @change="formChange($event, '教材')"
            >
              <el-option v-for="item in textbookTags" :key="item.id" :label="item.text_name" :value="item.id"></el-option>
            </el-select>
          </InputTopTip>
				</el-form-item>
				<el-form-item prop="dict_ids">
          <InputTopTip v-model="form.dict_ids" placeholder="目录">
            <el-cascader
              :disabled="!!!form.textbook_id"
              v-model="form.dict_ids"
              :props="{
                value: 'id',
                label: 'direct_name',
                expandTrigger: 'click'
              }"
              :options="dictIdTags"
              :show-all-levels="false"
              placeholder=""
              size="small"
              class="width-121"
              @change="formChange($event, '目录')"
            ></el-cascader>
          </InputTopTip>
				</el-form-item>

				<el-form-item prop="apply_grade">
          <InputTopTip v-model="form.apply_grade" placeholder="年级">
            <el-select v-model="form.apply_grade" size="small" disabled placeholder="" class="width-101">
              <el-option v-for="item in all_grade" :key="item.val" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </InputTopTip>
				</el-form-item>

				<el-form-item prop="apply_volume">
          <InputTopTip v-model="form.apply_volume" placeholder="上下册">
            <el-select v-model="form.apply_volume" size="small" disabled placeholder="" class="width-101">
              <el-option
                v-for="item in fb_apply_volume"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </InputTopTip>
				</el-form-item>

				<el-form-item prop="fb_type">
          <InputTopTip v-model="form.fb_type" placeholder="题型">
            <el-select
              v-model="form.fb_type"
              size="small"
              placeholder=""
              class="width-101"
              @change="formChange($event, '题型')"
            >
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </InputTopTip>
				</el-form-item>

				<el-form-item prop="fu_difficulty">
          <InputTopTip v-model="form.fu_difficulty" placeholder="难度">
            <el-select
              v-model="form.fu_difficulty"
              size="small"
              placeholder=""
              class="width-101"
              @change="formChange($event, '难度')"
            >
              <el-option
                v-for="item in difficultyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </InputTopTip>
				</el-form-item>

				<el-form-item prop="knowledge_point">
          <InputTopTip v-model="form.knowledge_point" placeholder="知识点">
            <el-cascader
              v-model="form.knowledge_point"
              :options="konwPointTags"
              clearable
              size="small"
              class="width-121"
              placeholder=""
              :show-all-levels="false"
              filterable
              :props="{
                value: 'id',
                label: 'knowledge_name',
                children: 'knowledges',
                expandTrigger: 'click',
                emitPath: false,
                filterable: true,
                multiple: false
              }"
              ref="knowPointRef"
              @change="formChange($event, '知识点')"
            >
            </el-cascader>
          </InputTopTip>
				</el-form-item>

				<el-form-item prop="competence">
          <InputTopTip v-model="form.competence" placeholder="能力点">
            <el-select
              v-model="form.competence"
              size="small"
              placeholder=""
              class="width-121"
              clearable
              @change="formChange($event, '能力点')"
            >
              <el-option
                v-for="item in powerPointTags"
                :key="item.knowledge_name"
                :label="item.knowledge_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </InputTopTip>
				</el-form-item>
			</div>

			<el-form-item class="form-reset">
				<el-button
					type="primary"
					@click=";(page = 1), getQuestionList()"
					size="small"
					class="action-btn"
					style="width: 70px; margin-right: 15px;"
					>搜索</el-button
				>
				<el-button @click="resetForm('form')" size="small" style="width: 70px;">重置</el-button>
			</el-form-item>
		</el-form>

		<div class="table">
			<div class="table-header">
				<div _flex="~">
					<!-- 1.2.0改动,删除多余 -->
					<!-- <div
						style="margin-right: 10px; background: #dcdfe6;"
						v-if="$store.state.user.userInfo.type === $api.account.types.TEACHER.value"
					>
						<el-button
							class="table-button"
							size="small"
							:type="fb_subject_id === item.id ? 'primary' : ''"
							v-for="item in tabs_teacher"
							:key="item.id"
							@click="handleTabClick(item.id)"
							>{{ item.name }}</el-button
						>
					</div>
					<div
						style="margin-right: 10px; background: #dcdfe6;"
						v-if="$store.state.user.userInfo.type === $api.account.types.TEACHER.value"
					>
						<el-button
							class="table-button"
							size="small"
							:type="fb_subject_id === item.id ? 'primary' : ''"
							v-for="item in tabs"
							:key="item.id"
							@click="handleTabClick(item.id)"
							>{{ item.name }}</el-button
						>
					</div> -->
					<el-button
						type="primary"
						@click="routePush('new')"
						size="small"
						v-if="
							($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
							($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
							($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP5100_${yy_ms}_1`]) && tabId == 1) ||
              ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && tabId == 2)
						"
					>
						<i class="el-icon-plus" style="margin-right: 7px;"></i>新建
					</el-button>
					<el-button
						size="small"
						style="background-color: #f7f8fa;"
						@click="$router.push(`/workbench/abilityList/${fb_subject_id}/resource`)"
						v-if="
              ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
              ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
              ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && tabId == 2) ||
              ($store.state.user.userInfo.type === $api.account.types.SCHOOL_ADMIN.value && tabId == 4) ||
              ($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP5110_${yy_ms}`]) && tabId == 1)
            "
					>
						<i class="el-icon-setting"></i>
					</el-button>
				</div>

				<el-button
					v-if="$permissions([`SP5100_${yy_ms}_2`]) && multipleSelection.length > 0"
					@click="deleteQuestionsList"
					size="small"
					:disabled="multipleSelection.length <= 0"
					:style="multipleSelection.length <= 0 && 'color: #4b4b4b !important;background: #9f9f9f !important'"
				>
					<i class="el-icon-delete" style="margin-right: 7px;"></i>批量删除
				</el-button>
			</div>

			<el-table
				:data="tableData"
				style="width: 100%; min-height: 570px;"
				@selection-change="handleSelectionChange"
				ref="multipleTable"
				tooltip-effect="dark"
			>
				<el-table-column
					type="selection"
					width="55"
					align="center"
          :key="'selection'"
					v-if="
						($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
						($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
            ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && tabId == 2)
					"
				></el-table-column>
				<!-- <el-table-column :key="'id'" label="编号" prop="id" width="60px">
					<template slot-scope="{ $index }">
						{{ $index + 1 + page_size * (page - 1) }}
					</template>
				</el-table-column> -->
        <el-table-column :key="'id'" label="编号" prop="id" width="80px"></el-table-column>
				<el-table-column :key="'body'" label="题干" prop="body" width="300px">
					<template slot-scope="{ row }">
						<el-tooltip placement="top" effect="light" _overflow="hidden">
							<div slot="content" style="max-width: 500px;" v-html="row.body"></div>
							<div
								style="-webkit-line-clamp: 1; overflow: hidden; display: -webkit-box; -webkit-box-orient: vertical;"
								v-html="row.body"
							></div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column :key="'question_apply_scope'" label="应用范围" prop="question_apply_scope" width="300px">
					<template slot-scope="{ row }">
						<el-tooltip
							placement="top"
							effect="light"
							_overflow="hidden"
							style="white-space: nowrap; text-overflow: ellipsis;"
						>
							<div>
								{{ filterScope(row.question_apply_scope[0]) }}
							</div>
							<div slot="content">
								<div style="line-height: 1.8;" v-for="(item, index) in row.question_apply_scope" :key="index">
									{{ filterScope(item) }}
								</div>
							</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column :key="'type'" label="题型" prop="type" align="left" width="80px">
					<template slot-scope="scope">
						<el-tooltip
							placement="top"
							effect="light"
							_overflow="hidden"
							style="white-space: nowrap; text-overflow: ellipsis;"
						>
							<div slot="content" style="line-height: 1.8;">{{ filteLabel(scope?.row?.type, typeList) }}</div>
							<div>{{ filteLabel(scope?.row?.type, typeList) }}</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column :key="'difficulty'" label="难度" prop="difficulty" align="left" width="100px"></el-table-column>
				<el-table-column :key="'knowledge_array'" label="知识点" prop="knowledge_array" align="left">
					<template slot-scope="{ row }">
						<el-tooltip
							placement="top"
							effect="light"
							_overflow="hidden"
							style="white-space: nowrap; text-overflow: ellipsis;"
						>
							<div slot="content" style="line-height: 1.8;">
								{{ row.knowledge_array?.map(item => item.knowledge_name).join('、') }}
							</div>
							<div>{{ row.knowledge_array?.map(item => item.knowledge_name).join('、') }}</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column :key="'competence_array'" label="能力点" prop="competence_array" align="left">
					<template slot-scope="{ row }">
						<el-tooltip
							placement="top"
							effect="light"
							_overflow="hidden"
							style="white-space: nowrap; text-overflow: ellipsis;"
						>
							<div slot="content" style="line-height: 1.8;">
								{{ row.competence_array?.map(item => item.knowledge_name).join('、') }}
							</div>
							<div>{{ row.competence_array?.map(item => item.knowledge_name).join('、') }}</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column :key="'is_public'" align="left" label="查看权限" prop="is_public" class-name="opscol" width="110px">
					<template v-slot="{ row }">
						{{ limits[row.is_public] }}
					</template>
				</el-table-column>
				<el-table-column align="left" label="创题者" prop="account" width="100px" :key="Math.random()"
          v-if="
            ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId != 5) ||
            $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
            $store.state.user.userInfo.type === $api.account.types.OTHER.value ||
            $store.state.user.userInfo.type === $api.account.types.SCHOOL_ADMIN.value
          "
        >
					<template v-slot="{ row }">
						<el-tooltip
							placement="top"
							effect="light"
							_overflow="hidden"
							style="white-space: nowrap; text-overflow: ellipsis;"
						>
							<div slot="content" style="line-height: 1.8;">
								{{ row?.account?.realname }}
							</div>
							<div>{{ row?.account?.realname }}</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column
					label="操作"
					align="center"
					v-if="$permissions([`SP5100_${yy_ms}_3`, `SP5100_${yy_ms}_4`, `SP5100_${yy_ms}_5`, `SP5100_${yy_ms}_6`])"
					width="160px"
				>
					<template slot-scope="{ row, $index }">
						<div style="display: flex; justify-content: center;">
							<el-tooltip placement="top" effect="light"
                v-if="
									($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value) ||
									($store.state.user.userInfo.type === $api.account.types.TEACHER.value) ||
									(
                    $store.state.user.userInfo.type === $api.account.types.OTHER.value &&
                    ((tabId == 1 && $permissions([`SP5100_${yy_ms}_3`])) || tabId == 3)
                  ) ||
                  ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value) ||
                  ($store.state.user.userInfo.type === $api.account.types.SCHOOL_ADMIN.value)
								"
              >
								<div slot="content">查看</div>
								<div
									class="icon-circle"
									style="background: white;"
									_border="1px solid [#ebeef5]"
									_m="r-5px"
									@click="routePush('look', row, $index)"
								>
									<i class="el-icon-view" style="color: #ff7143;"></i>
								</div>
							</el-tooltip>
							<el-tooltip
								placement="top"
								effect="light"
								v-if="
									($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
									($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
									($store.state.user.userInfo.type === $api.account.types.OTHER.value && tabId == 1 && $permissions([`SP5100_${yy_ms}_4`])) ||
                  ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && tabId == 2)
								"
							>
								<div slot="content">编辑</div>
								<div
									class="icon-circle"
									style="background: white;"
									_border="1px solid [#ebeef5]"
									_m="r-5px"
									@click="routePush('edit', row)"
								>
									<i class="el-icon-edit-outline" style="color: #3f6af7;"></i>
								</div>
							</el-tooltip>
							<el-tooltip
								placement="top"
								effect="light"
								v-if="
									($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
									($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
									($store.state.user.userInfo.type === $api.account.types.OTHER.value && tabId == 1 && $permissions([`SP5100_${yy_ms}_5`])) ||
                  ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && tabId == 2)
								"
							>
								<div slot="content">删除</div>
								<div class="icon-circle" _m="r-5px" @click="deleteRowClick(row)">
									<svg
										class="icon"
										aria-hidden="true"
										style="width: 100%; height: 100%; outline: none; box-shadow: none;"
									>
										<use xlink:href="#icon-deltred"></use>
									</svg>
								</div>
							</el-tooltip>
							<el-tooltip
								content="权限"
								placement="top"
								effect="light"
								v-if="
									($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
									($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
                  ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && tabId == 2) ||
                  ($store.state.user.userInfo.type === $api.account.types.OTHER.value && tabId == 1 && $permissions([`SP5100_${yy_ms}_6`]))
								"
							>
								<img
									style="width: 28px; height: 28px;"
									:src="require('@/assets/icons/svg/power.png')"
									class="icon-circle"
									@click=";(limitsVisible = true), (limitsRow = { id: row.id, is_public: row.is_public })"
								/>
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination">
				<div>总计：{{ total }}条/{{ last_page }}页</div>
				<el-pagination
					:current-page.sync="page"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="page_size"
					:total="total"
					background
					layout="prev, pager, next, jumper, sizes, slot"
					@current-change="handleCurrentChange"
					@size-change="handleSizeChange"
          :key="`${paginationKey}_${tabId}`"
				>
				</el-pagination>
			</div>

			<el-dialog :visible.sync="twoConfirmBoxFlag" width="30%" :before-close="beforeClose" class="dialog">
				<span slot="title" class="dialog-title">
					<i class="el-icon-warning-outline" style="margin-right: 12px;"></i>温馨提示
				</span>
				<div class="dialog-tip">是否删除该题目？</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="twoConfirmBoxFlag = false" :disabled="loading" size="small">取 消</el-button>
					<el-button type="primary" @click="twoConfirmClick" :loading="loading" size="small">确 定</el-button>
				</span>
			</el-dialog>

			<el-dialog
				class="scope-dialog"
				:width="'540px'"
				:before-close="
					() => {
						;(limitsVisible = false), (limitsRow = {})
					}
				"
				:close-on-click-modal="false"
				:visible="limitsVisible"
				@close="
					() => {
						;(limitsVisible = false), (limitsRow = {})
					}
				"
				title="权限"
			>
				<el-divider></el-divider>
				<div _m="y-20px">
					<span _m="r-15px">查看权限</span>
					<el-radio-group v-model="limitsRow.is_public" size="medium">
						<el-radio-button :label="0" :value="0" :key="0">私有题库</el-radio-button>
						<el-radio-button :label="1" :value="1" :key="1">公开题库</el-radio-button>
					</el-radio-group>
				</div>
				<div _text="[#9B9B9B]" _m="t-20px b-30px">
					非私有可用题目范围，其他符合条件范围的学生、教师都可以使用于测试和练习
				</div>
				<el-divider></el-divider>
				<div
					style="margin-top: 20px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;"
				>
					<el-button
						class="btn-close"
						@click="limitsVisible = false"
						style="width: 80px; height: 32px; line-height: 1px;"
						>取 消</el-button
					>
					<el-button
						class="btn-prim"
						type="primary"
						@click="updateState"
						style="width: 80px; height: 32px; line-height: 1px;"
						>确定</el-button
					>
				</div>
			</el-dialog>
		</div>
	</div>
</template>
<script>
import { mapValues, last } from 'lodash'
import {
	// SP5100_yy,
	SP5100_yy_1,
	SP5100_yy_2,
	SP5100_yy_3,
	SP5100_yy_4,
	SP5100_yy_5,
	// SP5100_ms,
	SP5100_ms_1,
	SP5100_ms_2,
	SP5100_ms_3,
	SP5100_ms_4,
	SP5100_ms_5
} from '@/utils/permissionMap.js'
import {
	// typeList,
  questionType,
	fb_apply_volume,
	difficultyList,
	primarySchool,
	middleSchool,
	highSchool,
	all_grade,
	limits,
	adminIdentity,
	teacherIdentity,
	schoolIdentity,
  researchIdentity
} from './const.js'
export default {
	props: {
		getTabsApi: Function
	},
	data() {
		return {
      questionType,
			primarySchool,
			middleSchool,
			highSchool,
			all_grade,
			limits,
			identity: [],
			adminIdentity,
			teacherIdentity,
			schoolIdentity,
      researchIdentity,
			limitsRow: {},
			limitsVisible: false,
			SP5100_yy_1,
			SP5100_yy_2,
			SP5100_yy_3,
			SP5100_yy_4,
			SP5100_yy_5,
			SP5100_ms_1,
			SP5100_ms_2,
			SP5100_ms_3,
			SP5100_ms_4,
			SP5100_ms_5,
			page: 1,
			page_size: 10,
			last_page: '',
			total: 0,
			tabs: [],
			tabs_teacher: [],
			fb_subject_id: 1,
			form: {
				fu_body_raw: '',
				publisher_id: '',
				textbook_id: '',
				dict_ids: '',
				apply_grade: '',
				apply_volume: '',
				fb_type: '',
				fu_difficulty: '',
				knowledge_point: [],
				competence: []
			},
			typeList: [],
			fb_apply_volume,
			difficultyList,
			tableData: [],
			multipleSelection: [],
			twoConfirmBoxFlag: false,
			row: {},
			loading: false,
			tabId: '',
			powerPointTags: [],
			konwPointTags: [],
			publisherIdTags: [],
			textbookTags: [],
			dictIdTags: [],
      paginationKey: new Date().getTime(),
      vModelChangeVisible: true
		}
	},
	created() {
		// this.initPage()
	},
	// beforeRouteUpdate() {
	//   this.initPage()
	// },
	watch: {
		$route: {
			handler(val) {
				const { sbid } = this.$route.params
				this.fb_subject_id = sbid
        this.initPage()
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		filterP(html) {
			let str = ''
			const pLabel = html?.match(/<p>(.*?)<\/p>/g)
			pLabel?.forEach(item => {
				str += item.replace(/<\/?p>/g, '')
			})
			str = str.replace(/<br>(.*?)/g, '')
			return str
		},
		async updateState() {
			await this.$api2.question_set.updateState(this.limitsRow.id, this.limitsRow)
			this.limitsVisible = false
			this.getQuestionList()
		},
		async formChange(event, type) {
      if (this.vModelChangeVisible) return
			switch (type) {
				case '出版社':
					this.$set(this.form, 'textbook_id', '')
					this.$set(this.form, 'apply_grade', '')
					this.$set(this.form, 'apply_volume', '')
					this.$set(this.form, 'dict_ids', '')
					await this.getTextbooks(event, 'textbookTags')
					break
				case '教材': {
					let book = this.textbookTags.find(item => item.id == event)
					// this.scopeGrade = [this.all_grade.find(item => item.val == book.text_classgrade)]
					// this.scopeVolume = [this.fb_apply_volume.find(item => item.value == book.text_volume)]
					const options = this.removeEmptyItems(book?.directory, 'children')
					this.dictIdTags = options
					this.$set(this.form, 'apply_grade', book.text_classgrade)
					this.$set(this.form, 'apply_volume', book.text_volume)
					this.$set(this.form, 'dict_ids', '')
					break
				}
				case '目录':
					break
			}
			this.page = 1
			this.getQuestionList()
		},
		removeEmptyItems(arr) {
			const newArr = []
			for (let i = 0; i < arr.length; i++) {
				const item = arr[i]
				if (item.children?.length >= 1) {
					item.children = this.removeEmptyItems(item.children)
				} else {
					item.children = undefined
				}
				newArr.push(item)
			}
			return newArr
		},
		async getTextbooks(publisherId, argsName = 'textbook') {
			const { data } = await this.$api.resource.getTextbooks({
				fb_subject_id: this.fb_subject_id,
				fb_publisher_id: publisherId,
				page_size: 99,
				page: 1,
        // scope_type: this.tabId
			scope_type: this.$store.state.user.userInfo.type === this.$api.account.types.TEACHER.value  ? 0 : this.tabId,
			})
			this[argsName] = data
		},
		async getKnowPointList() {
			const data = await this.$api.question_set.getKnowPointList({
        fb_subject_id: this.fb_subject_id
      })
			this.konwPointTags = data
		},
		async getPowerPointList() {
			const data = await this.$api.question_set.getPowerPointList({
        fb_subject_id: this.fb_subject_id
      })
			this.powerPointTags = data
		},
		async initPage() {
			const userInfo = this.$store.state.user.userInfo
			if (userInfo.type === this.$api.account.types.SCHOOL_ADMIN.value) {
				this.identity = this.schoolIdentity
			} else if (userInfo.type === this.$api.account.types.TEACHER.value) {
				this.identity = this.teacherIdentity
			} else if (userInfo.type === this.$api.account.types.PLATFORM_ADMIN.value) {
				this.identity = this.adminIdentity
			} else if (userInfo.type === this.$api.account.types.RESEARCH.value) {
        this.identity = this.researchIdentity
      } else {
				this.identity = this.adminIdentity
			}
      // try {
      //   const scope_type = JSON.parse(window.localStorage.getItem('look-detail')).params.scope_type
      //   this.tabId = this.identity.some(item => item.id == scope_type) ? scope_type : this.identity[0].id
      // } catch(err) {
      //   console.warn(err)
      //   this.tabId = this.identity[0].id
      // }

			this.typeList = this.questionType[this.fb_subject_id]
			this.getPowerPointList()
			this.getKnowPointList()
			await this.getPublisherId()

      try {
        // 每次刷新切换需要重置一下参数 标记（all can）
        this.form = mapValues(this.form, () => '')
        await this.getSearchParams()
        this.getQuestionList()
      } catch(err) {
        console.log('正常~')
        this.form = mapValues(this.form, () => '')
        this.tabId = this.identity[0].id
        this.getQuestionList()
      }
		},
    async getSearchParams(top = undefined) {
      this.vModelChangeVisible = true
      const searchParams = this.$store.state.searchParams[`${this.$route.name}_${this.fb_subject_id}`]
      console.log('this.$store.state.searchParams', this.$store.state.searchParams)
      if (top != undefined) {
        this.tabId = top
        this.page = searchParams[top]?.page || 1
        this.page_size = searchParams[top]?.page_size || 10
        this.form.fu_body_raw = searchParams[top]?.fu_body_raw
        this.form.fb_type = searchParams[top]?.fb_type
        this.form.fu_difficulty = searchParams[top]?.fu_difficulty
        this.form.knowledge_point = searchParams[top]?.knowledge_point
        this.form.competence = searchParams[top]?.competence

        this.form.publisher_id =  searchParams[top]?.publisher_id
        this.form.textbook_id = searchParams[top]?.textbook_id
        this.form.dict_ids = searchParams[top]?.dict_ids
        this.form.apply_grade = searchParams[top]?.apply_grade
        this.form.apply_volume = searchParams[top]?.apply_volume
      } else {
        try {
          const { historyTop } = searchParams
          this.tabId = historyTop
          this.page = searchParams[this.tabId]?.page
          this.page_size = searchParams[this.tabId]?.page_size
          this.form.fu_body_raw = searchParams[this.tabId]?.fu_body_raw
          this.form.fb_type = searchParams[this.tabId]?.fb_type
          this.form.fu_difficulty = searchParams[this.tabId]?.fu_difficulty
          this.form.knowledge_point = searchParams[this.tabId]?.knowledge_point
          this.form.competence = searchParams[this.tabId]?.competence

          this.form.publisher_id =  searchParams[this.tabId]?.publisher_id
          this.form.textbook_id = searchParams[this.tabId]?.textbook_id
          this.form.dict_ids = searchParams[this.tabId]?.dict_ids
          this.form.apply_grade = searchParams[this.tabId]?.apply_grade
          this.form.apply_volume = searchParams[this.tabId]?.apply_volume
        } catch(err) {
          this.tabId = this.identity[0]?.id
          this.page = 1
          this.page_size = 10
        }
      }
      setTimeout(() => {
        this.vModelChangeVisible = false
      }, 0)
      this.paginationKey = new Date().getTime()

      // select是动态的、需要保存额外字段
      if (this.form.publisher_id) {
        await this.getTextbooks(this.form.publisher_id, 'textbookTags')
        if (this.form.textbook_id) {
          let book = this.textbookTags.find(item => item.id == this.form.textbook_id)
          const options = this.removeEmptyItems(book?.directory, 'children')
          this.dictIdTags = options
        }
      }
    },
		async getPublisherId() {
			const { data } = await this.$api.question_set.getPublisherId({
        fb_subject_id: this.fb_subject_id
      })
			this.publisherIdTags = data
		},
		filteLabel(value, array) {
			if (!value) return
			return array[array.findIndex(item => item.value === value)]?.label || '——'
		},
		filteName(value, array) {
			if (!value) return
			return array[array.findIndex(item => item.val === value)]?.name || '——'
		},
		routePush(pathName, row, e) {
			let path, index
			if (row?.id) {
        // 倒序
				index = this.total - ((this.page - 1) * this.page_size + e)
        // 正序
        // index = (this.page - 1) * this.page_size + e
        // if (index == 0) index = 1
				window.localStorage.setItem(
					'look-detail',
					JSON.stringify({
						id: row.id,
						index: index,
            startIndex: e + 1 + this.page_size * (this.page - 1),
						total: this.total,
						params: {
							...this.form,
							fb_subject_id: this.fb_subject_id,
							scope_type: this.tabId
						}
					})
				)
				path = `/workbench/abilityList/${this.fb_subject_id}/${pathName}?id=${row.id}`
			} else {
				window.localStorage.removeItem('look-detail')
				path = `/workbench/abilityList/${this.fb_subject_id}/${pathName}?subjectId=${this.fb_subject_id}&scope_type=${this.tabId}`
			}
			this.$router.push(path)
		},
		async beforeClose(done) {
			if (this.loading) return
			done()
		},
		async getQuestionList() {
      const params = {
				...this.form,
				dict_id: last(this.form.dict_ids),
				scope_type: this.tabId,
				fb_subject_id: this.fb_subject_id,
				page_size: this.page_size,
				page: this.page
			}
      this.$store.commit('setTabSearchParams', { key: `${this.$route.name}_${this.fb_subject_id}`, top: this.tabId, params: params })
			const data = await this.$api.question_set.getQuestionList(params)
			this.tableData = data.data.map(item => {
				return {
					...item,
					visible: false
				}
			})
			this.total = data.meta.total
			this.last_page = data.meta.last_page
		},
		// 1.2.0改动逻辑全部删除，访客后续更改参考
		// async getSubjectData() {
		// 	const data = await this.$api.question_set.getSubjectData()
		// 	try {
		// 		if (this.$store.state.user?.userInfo?.type === this.$api.account.types.TEACHER.value) {
		// 			this.tabs_teacher = this.$store.state.user.userInfo.teachers[0]?.subjects.map(item => item)
		// 			this.fb_subject_id = this.tabs_teacher[0].id
		// 		} else if (this.$store.state.user.userInfo.type === this.$api.account.types.OTHER.value) {
		// 			if (this.$permissions([SP5100_yy])) {
		// 				const yy = data.data.filter(item => item.name == '音乐')[0]
		// 				this.tabs.push(yy)
		// 			}
		// 			if (this.$permissions([SP5100_ms])) {
		// 				const ms = data.data.filter(item => item.name == '美术')[0]
		// 				this.tabs.push(ms)
		// 			}
		// 			this.fb_subject_id = this.tabs[0].id
		// 		} else {
		// 			this.tabs = data.data
		// 			this.fb_subject_id = this.tabs[0].id
		// 		}
		// 	} catch (err) {
		// 		this.tabs_teacher = data.data
		// 		this.tabs = data.data
		// 		this.fb_subject_id = this.tabs[0].id
		// 	}
		// },
		async deleteQuestionsList() {
			if (this.multipleSelection.length <= 0) return
			this.$confirm('此操作将永久删除, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				const params = this.multipleSelection.map(item => {
					return item.id
				})
				await this.$api.question_set.deleteQuestionsList({
					ids: params
				})
				this.page = 1
				this.getQuestionList()
			})
		},
		async twoConfirmClick() {
			this.loading = true
			const data = await this.$api.question_set.deleteQuestions(this.row.id)
			if (data.success) {
				// 因为存在那种勾选但是还是点击删除的情况，需要手动删掉
				const index = this.multipleSelection.findIndex(item => item.id === this.row.id)
				this.multipleSelection.splice(index, 1)
				this.loading = false
				this.twoConfirmBoxFlag = false
				this.getQuestionList()
			} else {
				console.log('error')
			}
		},
		async deleteRowClick(row) {
			this.row = row
			this.$confirm('此操作将永久删除, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				const data = await this.$api.question_set.deleteQuestions(this.row.id)
				if (data.success) {
					// 因为存在那种勾选但是还是点击删除的情况，需要手动删掉
					const index = this.multipleSelection.findIndex(item => item.id === this.row.id)
					this.multipleSelection.splice(index, 1)
					this.loading = false
					this.twoConfirmBoxFlag = false
					this.getQuestionList()
				}
			})
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		handleTabClick(e) {
			this.fb_subject_id = e
			this.getQuestionList()
		},
    handlePrivateClick(e) {
      this.getSearchParams(e)
      this.$nextTick(() => {
        this.$refs['multipleTable']?.doLayout()
      })
      this.getQuestionList()
    },
		onSubmit() {
		},
		resetForm(formName) {
			this.$refs.knowPointRef.$refs.panel.menus = [this.$refs.knowPointRef.$refs.panel.store.getNodes()]
			this.$refs[formName].resetFields()
      this.form = mapValues(this.form, () => '')
			this.getQuestionList()
		},
		// 更改条数
		handleSizeChange(val) {
			this.page = 1
			this.page_size = val
			this.getQuestionList()
		},
		// 更改页码
		handleCurrentChange(val) {
			this.page = val
			this.getQuestionList()
		},
		filterScope(item) {
      const data = item?.directory
      let direct_name = undefined
      if (Array.isArray(data)) {
        direct_name = data.map(e => e.direct_name).join('、')
      } else {
        direct_name = data?.direct_name
      }
			return item
				? `${item?.publisher?.name || '全部'} / ${this.filteName(item.apply_grade, all_grade) || '全部'} / ${
						item?.textbook?.text_name || '全部'
          } / ${direct_name || '全部'}`
				: ''
		}
	},
	computed: {
		yy_ms() {
			return this.fb_subject_id == 1 ? 'yy' : this.fb_subject_id == 2 ? 'ms' : ''
		}
	}
}
</script>
<style scoped lang="scss">
.action-btn:focus {
	background-color: #ff5e2a;
	border-color: #ff5e2a;
	opacity: 1 !important;
}
.tabs-form {
	min-height: 102px;
	border-radius: 8px 8px 8px 8px;
	opacity: 1;
}
.table {
	margin-top: 10px;
	padding: 20px;
	background: #ffffff;
	display: block;
}
/deep/ .el-table tbody tr td:last-child {
	padding-right: 0 !important;
}
.table-button {
	margin: 0;
}

.dialog {
	/deep/ dialog-title {
		font-size: 18px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #323232;
	}
	/deep/ .el-dialog__body {
		border-top: 2px solid #f8f8f8;
		border-bottom: 2px solid #f8f8f8;
		margin: 1px 20px;
	}
	/deep/ .el-dialog__footer {
		margin-top: 24px;
		margin-bottom: 25px;
	}
}
.dialog-tip {
	font-size: 18px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: bold;
	color: #323232;
	margin-top: 63px;
	margin-bottom: 52px;
	text-align: center;
}
.dialog-title {
	font-size: 18px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: bold;
	color: #d83a3a;
}
.pagination {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 26px;
}
.icon-circle {
	width: 28px;
	height: 28px;
	border-radius: 100%;
	background: #fff8f5;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
// .icon-circle:nth-child(2) {
// 	margin-left: 15px;
// 	margin-right: 15px;
// }
.table-header {
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
}
.tabs {
	display: flex;
	align-items: center;
	border-bottom: 1px solid #eeeeee;
	height: 39px;
	background: #ffffff;
}
.tabs-pane-avtive {
	color: #4a4a4a !important;
	position: relative;
}
.tabs-pane-avtive::after {
	content: '';
	display: block;
	position: absolute;
	top: 38px;
	width: 43px;
	height: 2px;
	background: #ff5e2a;
	border-radius: 0px 0px 0px 0px;
}
.tabs-pane {
	margin-left: 17px;
	margin-right: 8px;
	width: 36px;
	height: 39px;
	font-size: 18px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: bold;
	color: #bbbbbb;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}
.form {
	padding: 15px 0px 0px 19px !important;
	display: flex;
	justify-content: space-between;
	min-height: 40px;
	background: #ffffff;
}
.form-contain {
	flex-basis: 80%;
	/deep/ .el-form-item {
		margin-bottom: 12px;
	}
}
.form-reset {
	display: flex;
	flex-wrap: nowrap;
}
.width-121 {
	width: 121px;
}
.width-101 {
	width: 101px;
}
.width-166 {
	width: 166px;
}
.width-264 {
	width: 264px;
}

// 少婷提的——表格80
/deep/.el-table thead th {
	background-color: #fafafa;
	border-top: 1px solid #fff;
}
</style>
